export default "__VITE_ASSET__sITlrZKh__"